import { createIcon } from './_icon';

// mail-3
const MailSolidIcon = createIcon(() => (
	<svg width="1em" height="1em" fill="none" viewBox="0 0 24 24">
		<path fill="currentColor" d="M2 6.882V4h20v2.882l-10 5-10-5Z" />
		<path fill="currentColor" d="M2 9.118V20h20V9.118l-10 5-10-5Z" />
	</svg>
));

export default MailSolidIcon;
